import { render, staticRenderFns } from "./PageNewPost.vue?vue&type=template&id=5db03ccc&scoped=true&"
import script from "./PageNewPost.vue?vue&type=script&lang=js&"
export * from "./PageNewPost.vue?vue&type=script&lang=js&"
import style0 from "./PageNewPost.vue?vue&type=style&index=0&id=5db03ccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db03ccc",
  null
  
)

export default component.exports